// Jeder Block muss zweimal hinzugefügt werden.
// 1. Block importieren:
import BlockNotFound from './BlockNotFound'
import TextBlock from './TextBlock'
import ImageBlock from './ImageBlock'
import HeaderBlock from './HeaderBlock'
import CenteredTextBlock from './CenteredTextBlock'
import TextWithImageBlock from './TextWithImageBlock'
import TextWithListBlock from './TextWithListBlock'
import TextWithPortraitImageBlock from './TextWithPortraitImageBlock'
import QuoteBlock from './QuoteBlock'
import TextWithQuoteBlock from './TextWithQuoteBlock'
import VideoBlock from './VideoBlock'
import VerticalTimelineBlock from './VerticalTimelineBlock'
import AcademyCourseBlock from './AcademyCourseBlock'
import AccordionBlock from './AccordionBlock'
import AnchorBlock from './AnchorBlock'
import ArticleTripleTeaserBlock from './ArticleTripleTeaserBlock'
import BackgroundBlock from './BackgroundBlock'
import BigNumbersBlock from './BigNumbersBlock'
import BigTextBlock from './BigTextBlock'
import ChangelogBlock from './ChangelogBlock'
import CustomArticleTripleTeaserBlock from './CustomArticleTripleTeaserBlock'
import DoubleTeaserBlock from './DoubleTeaserBlock'
import DownloadsBlock from './DownloadsBlock'
import EmbedBlock from './EmbedBlock'
import EventsFromPartnerPortalBlock from './EventsFromPartnerportalBlock'
import FeatureTeaserBlock from './FeatureTeaserBlock'
import FullscreenImageBlock from './FullscreenImageBlock'
import FullscreenVideoBlock from './FullscreenVideoBlock'
import GalleryBlock from './GalleryBlock'
import HeroBlock from './HeroBlock'
import HeroRotationBlock from './HeroRotationBlock'
import HighlightsBlock from './HighlightsBlock'
import ImageSliderBlock from './ImageSliderBlock'
import InspirationBlock from './InspirationBlock'
import LogoLinksBlock from './LogoLinksBlock'
import InspirationHeaderBlock from './InspirationHeaderBlock'
import PconUiToolBlock from './PconUiToolBlock'
import PinpointBlock from './PinpointBlock'
import ProductCategoryTeaserBlock from './ProductCategoryTeaserBlock'
import ProductGalleryBlock from './ProductGalleryBlock'
import QuadrupleTeaserBlock from './QuadrupleTeaserBlock'
import ReferenceSliderBlock from './ReferenceSliderBlock'
import StaticDownloadsBlock from './StaticDownloadsBlock'
import TableBlock from './TableBlock'
import ContactPersonBlock from './ContactPersonBlock'
import TeamBlock from './TeamBlock'
import TestimonialBlock from './TestimonialBlock'
import TripleTeaserBlock from './TripleTeaserBlock'
import ButtonsBlock from './ButtonsBlock'
import AccordionTextWithImageBlock from './AccordionTextWithImageBlock'
import PostitBlock from './PostitBlock'
import PolaroidBlock from './PolaroidBlock'
import ChecklistBlock from './ChecklistBlock'
import InterviewBlock from './InterviewBlock'
import DealerSearchBlock from './DealerSearchBlock'
import ChartBlock from './ChartBlock'
import SapServiceBlock from './SapServiceBlock'
import RegistrationButtonBlock from './RegistrationButtonBlock'
import ContactBannerBlock from './ContactBannerBlock'
import VideoListBlock from './VideoListBlock'
import CountdownBlock from './CountdownBlock'
import HeroCountdownBlock from './HeroCountdownBlock'
import DoubleEmbedBlock from './DoubleEmbedBlock'
import DateListingBlock from './DateListingBlock'
import ArticleTeaserBlock from './ArticleTeaserBlock'
import FaqListingBlock from './FaqListingBlock'
import DidYouKnowBlock from './DidYouKnowBlock'
import ProductInnovationBlock from './ProductInnovationBlock'
import CategoriesBlock from './CategoriesBlock'
import IntroBoxBlock from './IntroBoxBlock'
import TimelineSliderBlock from './TimelineSliderBlock'
import QuoteSliderBlock from './QuoteSliderBlock'

// 2. CMS-Block auf React-Block mappen:
const BlocksList = {
  text_block: TextBlock,
  image_block: ImageBlock,
  quote_block: QuoteBlock,
  text_with_image_block: TextWithImageBlock,
  text_with_list_block: TextWithListBlock,
  text_with_portrait_image_block: TextWithPortraitImageBlock,
  text_with_quote_block: TextWithQuoteBlock,
  video_block: VideoBlock,
  vertical_timeline_block: VerticalTimelineBlock,

  academy_course_block: AcademyCourseBlock,
  accordion_block: AccordionBlock,
  accordion_text_with_image_block: AccordionTextWithImageBlock,
  anchor_block: AnchorBlock,
  article_triple_teaser_block: ArticleTripleTeaserBlock,
  background_block: BackgroundBlock,
  big_numbers_block: BigNumbersBlock,
  big_text_block: BigTextBlock,
  buttons_block: ButtonsBlock,
  centered_text_block: CenteredTextBlock,
  changelog_block: ChangelogBlock,
  contact_person_block: ContactPersonBlock,
  custom_article_triple_teaser_block: CustomArticleTripleTeaserBlock,
  double_teaser_block: DoubleTeaserBlock,
  downloads_block: DownloadsBlock,
  embed_block: EmbedBlock,
  events_from_partnerportal_block: EventsFromPartnerPortalBlock,
  feature_teaser_block: FeatureTeaserBlock,
  fullscreen_image_block: FullscreenImageBlock,
  fullscreen_video_block: FullscreenVideoBlock,
  gallery_block: GalleryBlock,
  header_block: HeaderBlock,
  hero_block: HeroBlock,
  hero_rotation_block: HeroRotationBlock,
  hero_countdown_block: HeroCountdownBlock,
  highlights_block: HighlightsBlock,
  image_slider_block: ImageSliderBlock,
  inspiration_block: InspirationBlock,
  inspiration_header_block: InspirationHeaderBlock,
  logo_links_block: LogoLinksBlock,
  pcon_ui_took_block: PconUiToolBlock,
  pinpoint_block: PinpointBlock,
  product_category_teaser_block: ProductCategoryTeaserBlock,
  product_gallery_block: ProductGalleryBlock,
  quadruple_teaser_block: QuadrupleTeaserBlock,
  reference_slider_block: ReferenceSliderBlock,
  static_downloads_block: StaticDownloadsBlock,
  table_block: TableBlock,
  team_block: TeamBlock,
  testimonial_block: TestimonialBlock,
  triple_teaser_block: TripleTeaserBlock,
  video_list_block: VideoListBlock,
  timeline_slider_block: TimelineSliderBlock,

  dealer_search_block: DealerSearchBlock,

  postit_block: PostitBlock,
  polaroid_block: PolaroidBlock,
  checklist_block: ChecklistBlock,
  interview_block: InterviewBlock,
  chart_block: ChartBlock,
  contact_banner_block: ContactBannerBlock,

  sap_service: SapServiceBlock,
  registration_button_block: RegistrationButtonBlock,
  countdown_block: CountdownBlock,
  double_embed_block: DoubleEmbedBlock,
  date_listing_block: DateListingBlock,

  article_teaser_block: ArticleTeaserBlock,
  faq_listing_block: FaqListingBlock,
  did_you_know_block: DidYouKnowBlock,
  product_innovation_block: ProductInnovationBlock,
  categories_block: CategoriesBlock,
  intro_box_block: IntroBoxBlock,
  quote_slider_block: QuoteSliderBlock,
}

// Diese Logik kann unverändert bleiben
const Blocks = (type) => {
  if (typeof BlocksList[type] === 'undefined') {
    return BlockNotFound
  }
  return BlocksList[type]
}

export default Blocks
